import { useState, useEffect } from "react";
import Header from "./shared/header";

import DesktopLayout from "./shared/desktop_layout";
import MobileLayout from "./shared/mobile_layout";

function ContactUs() {
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    // console.log("hewej");
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Zoho form validation functions
  useEffect(() => {
    // Define the validation functions globally
    window.validateEmail6790000000000962015 = function () {
      var form = document.forms["WebToLeads6790000000000962015"];
      var emailFld = form.querySelectorAll("[ftype=email]");
      var i;
      for (i = 0; i < emailFld.length; i++) {
        var emailVal = emailFld[i].value;
        if (emailVal.replace(/^\s+|\s+$/g, "").length != 0) {
          var atpos = emailVal.indexOf("@");
          var dotpos = emailVal.lastIndexOf(".");
          if (
            atpos < 1 ||
            dotpos < atpos + 2 ||
            dotpos + 2 >= emailVal.length
          ) {
            alert("Please enter a valid email address.");
            emailFld[i].focus();
            return false;
          }
        }
      }
      return true;
    };

    window.checkMandatory6790000000000962015 = function () {
      var mndFileds = new Array(
        "Company",
        "First Name",
        "Last Name",
        "Email",
        "Mobile"
      );
      var fldLangVal = new Array(
        "Company",
        "First Name",
        "Last Name",
        "Email",
        "Mobile"
      );
      for (var i = 0; i < mndFileds.length; i++) {
        var fieldObj =
          document.forms["WebToLeads6790000000000962015"][mndFileds[i]];
        if (fieldObj) {
          if (fieldObj.value.replace(/^\s+|\s+$/g, "").length == 0) {
            if (fieldObj.type == "file") {
              alert("Please select a file to upload.");
              fieldObj.focus();
              return false;
            }
            alert(fldLangVal[i] + " cannot be empty.");
            fieldObj.focus();
            return false;
          } else if (fieldObj.nodeName == "SELECT") {
            if (fieldObj.options[fieldObj.selectedIndex].value == "-None-") {
              alert(fldLangVal[i] + " cannot be none.");
              fieldObj.focus();
              return false;
            }
          } else if (fieldObj.type == "checkbox") {
            if (fieldObj.checked == false) {
              alert("Please accept " + fldLangVal[i]);
              fieldObj.focus();
              return false;
            }
          }
          try {
            if (fieldObj.name == "Last Name") {
              var name = fieldObj.value;
            }
          } catch (e) {}
        }
      }
      if (!window.validateEmail6790000000000962015()) {
        return false;
      }
      var urlparams = new URLSearchParams(window.location.search);
      if (urlparams.has("service") && urlparams.get("service") === "smarturl") {
        var webform = document.getElementById("webform6790000000000962015");
        var service = urlparams.get("service");
        var smarturlfield = document.createElement("input");
        smarturlfield.setAttribute("type", "hidden");
        smarturlfield.setAttribute("value", service);
        smarturlfield.setAttribute("name", "service");
        webform.appendChild(smarturlfield);
      }
      document
        .querySelector(".crmWebToEntityForm .formsubmit")
        .setAttribute("disabled", true);
    };

    window.tooltipShow6790000000000962015 = function (el) {
      var tooltip = el.nextElementSibling;
      var tooltipDisplay = tooltip.style.display;
      if (tooltipDisplay == "none") {
        var allTooltip = document.getElementsByClassName("zcwf_tooltip_over");
        for (var i = 0; i < allTooltip.length; i++) {
          allTooltip[i].style.display = "none";
        }
        tooltip.style.display = "block";
      } else {
        tooltip.style.display = "none";
      }
    };

    // Cleanup function
    return () => {
      delete window.validateEmail6790000000000962015;
      delete window.checkMandatory6790000000000962015;
      delete window.tooltipShow6790000000000962015;
    };
  }, []);

  const Layout = ({ children, backgroundColor }) => {
    return screenSize <= 768 ? (
      <MobileLayout backgroundColor={backgroundColor}>{children}</MobileLayout>
    ) : (
      <DesktopLayout backgroundColor={backgroundColor}>
        {children}
      </DesktopLayout>
    );
  };

  return (
    <div>
      <Layout backgroundColor="black">
        <div>
          <Header />
          <div>&nbsp;</div>
          <div className="mt-[101px] w-[87%] sm:w-[80%] mx-auto text-[#ffffff]">
            <div className="text-[48px] md:text-[56px] lg:text-[64px] RoobertMedium leading-[120%] mb-6">
              Contact Us
            </div>
            <div className="mt-[24px] leading-[140%] tracking-[-0.4px] text-[18px] md:text-[20px] lg:text-[22px] RoobertRegular md:w-[60%] lg:w-[50%] opacity-90">
              Reach out to us to explore how our Generative AI, Machine Learning
              and Data solutions can drive transformative growth for your
              business. We are here to deliver unmatched value, innovation, and
              domain expertise, guiding you towards sustainable success. Reach
              out today to start the conversation.
            </div>
          </div>

          <div className="mt-[80px] md:mt-[100px] flex flex-col lg:flex-row w-[87%] sm:w-[80%] mx-auto mb-[120px] md:mb-[160px] gap-12 lg:gap-16">
            {/* Zoho CRM Form */}
            <div className="flex-1 lg:w-[60%]">
              <div
                id="crmWebToEntityForm"
                className="zcwf_lblLeft crmWebToEntityForm"
                style={{
                  backgroundColor: "white",
                  color: "black",
                  maxWidth: "100%",
                }}
                dangerouslySetInnerHTML={{
                  __html: `
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <META HTTP-EQUIV="content-type" CONTENT="text/html;charset=UTF-8">
                    <form id="webform6790000000000962015" action="https://crm.zoho.com/crm/WebToLeadForm" name="WebToLeads6790000000000962015" method="POST" onSubmit="javascript:document.charset='UTF-8'; return checkMandatory6790000000000962015()" accept-charset="UTF-8">
                      <input type="text" style="display:none;" name="xnQsjsdp" value="b4c2cf86312d164f76a0afa2f7a3638d0c209f9384c3c983e4b3e654f69a1b8d"></input>
                      <input type="hidden" name="zc_gad" id="zc_gad" value=""></input>
                      <input type="text" style="display:none;" name="xmIwtLD" value="67b7c039258832b2bba1662bbcb752b67bf65b10d4c69c1fd381c9bd9858461a8c7b4b42668cc4d5509a8331be15abc9"></input>
                      <input type="text" style="display:none;" name="actionType" value="TGVhZHM="></input>
                      <input type="text" style="display:none;" name="returnURL" value="null"></input>
                      <style>
                        html,body{
                          margin: 0px;
                        }
                        .formsubmit.zcwf_button{
                          color: black !important;
                          background: #66FF00 !important;
                          border: none !important;
                          padding: 14px 28px !important;
                          border-radius: 8px !important;
                          font-weight: 600 !important;
                          font-size: 16px !important;
                          cursor: pointer !important;
                          transition: all 0.2s ease !important;
                          font-family: 'Roobert', sans-serif !important;
                        }
                        .formsubmit.zcwf_button:hover{
                          background: #5AE600 !important;
                          transform: translateY(-1px) !important;
                          box-shadow: 0 4px 12px rgba(102, 255, 0, 0.3) !important;
                        }
                        #crmWebToEntityForm.zcwf_lblLeft{
                          width: 100%;
                          padding: 40px;
                          margin: 0 auto;
                          box-sizing: border-box;
                          background: white;
                          border-radius: 16px;
                          box-shadow: 0 8px 32px rgba(0,0,0,0.12);
                          border: 1px solid rgba(255,255,255,0.1);
                        }
                        #crmWebToEntityForm.zcwf_lblLeft *{
                          box-sizing: border-box;
                        }
                        #crmWebToEntityForm {text-align: left;
                        }
                        #crmWebToEntityForm *{
                          direction: ltr;
                        }
                        .zcwf_lblLeft .zcwf_title{
                          word-wrap: break-word;
                          padding: 0px 0px 32px;
                          font-weight: 600;
                          font-size: 28px;
                          color: #0A1931;
                          font-family: 'Roobert', sans-serif;
                          margin-bottom: 8px;
                        }
                        .zcwf_lblLeft.cpT_primaryBtn:hover{
                          background: #5AE600 !important;
                          box-shadow: 0 4px 12px rgba(102, 255, 0, 0.3) !important;
                          border: 0 !important;
                          color: #fff !important;
                          outline: 0 !important;
                        }
                        .zcwf_lblLeft .zcwf_col_fld input[type=text], input[type=password], .zcwf_lblLeft .zcwf_col_fld textarea{
                          width: 100%;
                          border: 2px solid #E5E7EB !important;
                          resize: vertical;
                          border-radius: 12px;
                          padding: 16px 20px;
                          font-size: 16px;
                          font-family: 'Roobert', sans-serif;
                          transition: all 0.2s ease;
                          background: #F9FAFB;
                          font-weight: 400;
                        }
                        .zcwf_lblLeft .zcwf_col_fld input[type=text]:focus, .zcwf_lblLeft .zcwf_col_fld textarea:focus{
                          border-color: #66FF00 !important;
                          outline: none !important;
                          box-shadow: 0 0 0 3px rgba(102, 255, 0, 0.1) !important;
                          background: white !important;
                        }
                        .zcwf_lblLeft .zcwf_col_lab{
                          width: 100%;
                          word-break: break-word;
                          padding: 0px 0px 12px;
                          margin-right: 0px;
                          margin-top: 0px;
                          float: none;
                          min-height: 1px;
                          font-weight: 600;
                          color: #0A1931;
                          font-family: 'Roobert', sans-serif;
                          font-size: 16px;
                        }
                        .zcwf_lblLeft .zcwf_col_fld{
                          float: none;
                          width: 100%;
                          padding: 0px 0px 24px;
                          position: relative;
                          margin-top: 0px;
                        }
                        .zcwf_lblLeft .zcwf_privacy {padding: 6px;
                        }
                        .zcwf_lblLeft .wfrm_fld_dpNn {display: none;
                        }
                        .dIB {display: inline-block;
                        }
                        .zcwf_lblLeft .zcwf_col_fld_slt{
                          width: 100%;
                          border: 2px solid #E5E7EB;
                          background: #F9FAFB;
                          border-radius: 12px;
                          font-size: 16px;
                          float: none;
                          resize: vertical;
                          padding: 16px 20px;
                          font-family: 'Roobert', sans-serif;
                        }
                        .zcwf_lblLeft .zcwf_row:after, .zcwf_lblLeft .zcwf_col_fld:after{
                          content: '';
                          display: table;
                          clear: both;
                        }
                        .zcwf_lblLeft .zcwf_col_help{
                          float: none;
                          margin-left: 0px;
                          font-size: 14px;
                          max-width: 100%;
                          word-break: break-word;
                          color: #6B7280;
                          margin-top: 8px;
                        }
                        .zcwf_lblLeft .zcwf_help_icon{
                          cursor: pointer;
                          width: 16px;
                          height: 16px;
                          display: inline-block;
                          background: #fff;
                          border: 1px solid #c0c6cc;
                          color: #c1c1c1;
                          text-align: center;
                          font-size: 11px;
                          line-height: 16px;
                          font-weight: bold;
                          border-radius: 50%;
                        }
                        .zcwf_lblLeft .zcwf_row {margin: 0px 0px 24px;
                        }
                        .zcwf_lblLeft .formsubmit{
                          margin-right: 16px;
                          cursor: pointer;
                          color: #313949;
                          font-size: 16px;
                        }
                        .zcwf_lblLeft .zcwf_privacy_txt{
                          width: 90%;
                          color: rgb(0, 0, 0);
                          font-size: 12px;
                          font-family: Arial;
                          display: inline-block;
                          vertical-align: top;
                          color: #313949;
                          padding-top: 2px;
                          margin-left: 6px;
                        }
                        .zcwf_lblLeft .zcwf_button{
                          font-size: 14px;
                          color: black;
                          border: 2px solid #E5E7EB;
                          padding: 12px 24px;
                          border-radius: 8px;
                          cursor: pointer;
                          max-width: 120px;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          background: white;
                          transition: all 0.2s ease;
                          font-family: 'Roobert', sans-serif;
                        }
                        .zcwf_lblLeft .zcwf_button:hover{
                          background: #F3F4F6;
                          border-color: #D1D5DB;
                        }
                        .zcwf_lblLeft .zcwf_tooltip_over{
                          position: relative;
                        }
                        .zcwf_lblLeft .zcwf_tooltip_ctn{
                          position: absolute;
                          background: #dedede;
                          padding: 3px 6px;
                          top: 3px;
                          border-radius: 4px;
                          word-break: break-word;
                          min-width: 100px;
                          max-width: 150px;
                          color: #313949;
                          z-index: 100;
                        }
                        .zcwf_lblLeft .zcwf_ckbox{
                          float: left;
                        }
                        .zcwf_lblLeft .zcwf_file{
                          width: 55%;
                          box-sizing: border-box;
                          float: left;
                        }
                        .cBoth:after{
                          content: '';
                          display: block;
                          clear: both;
                        }
                        @media all and (max-width: 600px){
                          .zcwf_lblLeft .zcwf_col_lab, .zcwf_lblLeft .zcwf_col_fld{
                            width: 100%;
                            float: none !important;
                          }
                          .zcwf_lblLeft .zcwf_col_help {width: 100%;
                          }
                          #crmWebToEntityForm.zcwf_lblLeft{
                            padding: 24px;
                          }
                        }
                      </style>
                      <div class="zcwf_title" style="max-width: 600px;color: #0A1931; font-family:'Roobert', sans-serif; font-size: 28px; font-weight: 600;">
                        Get in Touch
                      </div>
                      <div class="zcwf_row">
                        <div class="zcwf_col_lab" style="font-size:16px; font-family: 'Roobert', sans-serif; font-weight: 600; color: #0A1931;">
                          <label for="Company">
                            Company
                            <span style="color:#EF4444;">
                              *
                            </span>
                          </label>
                        </div>
                        <div class="zcwf_col_fld">
                          <input type="text" id="Company" aria-required="true" aria-label="Company" name="Company" aria-valuemax="200" maxlength="200" placeholder="Enter your company name"></input>
                          <div class="zcwf_col_help">
                          </div>
                        </div>
                      </div>
                      <div class="zcwf_row">
                        <div class="zcwf_col_lab" style="font-size:16px; font-family: 'Roobert', sans-serif; font-weight: 600; color: #0A1931;">
                          <label for="Last_Name">
                            Last Name
                            <span style="color:#EF4444;">
                              *
                            </span>
                          </label>
                        </div>
                        <div class="zcwf_col_fld">
                          <input type="text" id="Last_Name" aria-required="true" aria-label="Last Name" name="Last Name" aria-valuemax="80" maxlength="80" placeholder="Enter your last name"></input>
                          <div class="zcwf_col_help">
                          </div>
                        </div>
                      </div>
                      <div class="zcwf_row">
                        <div class="zcwf_col_lab" style="font-size:16px; font-family: 'Roobert', sans-serif; font-weight: 600; color: #0A1931;">
                          <label for="First_Name">
                            First Name
                            <span style="color:#EF4444;">
                              *
                            </span>
                          </label>
                        </div>
                        <div class="zcwf_col_fld">
                          <input type="text" id="First_Name" aria-required="true" aria-label="First Name" name="First Name" aria-valuemax="40" maxlength="40" placeholder="Enter your first name"></input>
                          <div class="zcwf_col_help">
                          </div>
                        </div>
                      </div>
                      <div class="zcwf_row">
                        <div class="zcwf_col_lab" style="font-size:16px; font-family: 'Roobert', sans-serif; font-weight: 600; color: #0A1931;">
                          <label for="Mobile">
                            Mobile
                            <span style="color:#EF4444;">
                              *
                            </span>
                          </label>
                        </div>
                        <div class="zcwf_col_fld">
                          <input type="text" id="Mobile" aria-required="true" aria-label="Mobile" name="Mobile" aria-valuemax="30" maxlength="30" placeholder="Enter your mobile number"></input>
                          <div class="zcwf_col_help">
                          </div>
                        </div>
                      </div>
                      <div class="zcwf_row">
                        <div class="zcwf_col_lab" style="font-size:16px; font-family: 'Roobert', sans-serif; font-weight: 600; color: #0A1931;">
                          <label for="Email">
                            Email
                            <span style="color:#EF4444;">
                              *
                            </span>
                          </label>
                        </div>
                        <div class="zcwf_col_fld">
                          <input type="text" ftype="email" autocomplete="false" id="Email" aria-required="true" aria-label="Email" name="Email" aria-valuemax="100" crmlabel="" maxlength="100" placeholder="Enter your email address"></input>
                          <div class="zcwf_col_help">
                          </div>
                        </div>
                      </div>
                      <div class="zcwf_row">
                        <div class="zcwf_col_lab" style="font-size:16px; font-family: 'Roobert', sans-serif; font-weight: 600; color: #0A1931;">
                          <label for="Description">
                            Description
                          </label>
                        </div>
                        <div class="zcwf_col_fld">
                          <textarea style="font-family: 'Roobert', sans-serif; min-height: 120px;" aria-multiline="true" id="Description" aria-required="false" aria-label="Description" name="Description" placeholder="Tell us about your project or inquiry..."></textarea>
                          <div class="zcwf_col_help">
                          </div>
                        </div>
                      </div>
                      <input type="text" type="hidden" style="display: none;" name="aG9uZXlwb3Q" value=""/>
                      <div class="zcwf_row">
                        <div class="zcwf_col_lab">
                        </div>
                        <div class="zcwf_col_fld">
                          <input type="submit" id="formsubmit" role="button" class="formsubmit zcwf_button" value="Submit" aria-label="Submit" title="Submit"></input>
                          <input type="reset" class="zcwf_button" role="button" name="reset" value="Reset" aria-label="Reset" title="Reset"></input>
                        </div>
                      </div>
                      <script id="wf_anal" src="https://crm.zohopublic.com/crm/WebFormAnalyticsServeServlet?rid=427d0bf2c69789bc060e6e8f48a57eb07b20262cc4612cd3134519324a3f65725d9182432c535d54eb916ade10f30a8bgid8b9b8a8a974bcc383f3a97b0cf81d549c69801ff8e21e66f409c6f1c3b4ac58egidfae39809099c29d19f163313b2baa662542e7aacc5f0cf4e556e09822c8d4b83gid3776db5577d058cfb90e0614e109d34e4525ac7601200be0271d3455e26bf98a&tw=fff1a51a80a1e3b2ff01516d508a85018193658d48618242d50ea4f3606047fa"></script>
                    </form>
                  `,
                }}
              />
            </div>

            <div className="bg-white text-[#000] py-[40px] px-[32px] h-fit gap-4 flex flex-col lg:w-[40%] rounded-[16px] border-[1px] border-[rgba(255, 255, 255, 0.10)] shadow-lg">
              <div className="text-[24px] font-semibold tracking-[-0.4px] text-[#0A1931]">
                Reach Out
              </div>
              <div className="space-y-2">
                <div>
                  <div className="text-[#6B7280] mb-6">
                    Our teams across ASEAN and beyond are ready to engage. Have
                    a project in mind, need a demo, or want to partner with us?
                  </div>
                  <div className="text-[#0A1931] font-medium mb-2">
                    📩 connect@onebyzero.ai
                  </div>
                  <div className="text-[#0A1931] space-y-1 mb-2">
                    <div>
                      📍 109 North Bridge Road, #05-21, Singapore 179097
                    </div>
                  </div>
                </div>

                {/* <div>
                  <div className="text-[20px] font-semibold text-[#0A1931] mb-2">
                    Visit us
                  </div>
                  <div className="text-[#6B7280] mb-3">
                    Come say hello at our office HQ
                  </div>
                  <div className="text-[#0A1931] space-y-1">
                    <div>
                      📍 109 North Bridge Road, #05-21, Singapore 179097
                    </div>
                    <div>109 North Bridge Road</div>
                    <div>#05-21</div>
                    <div>Singapore 179097</div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div>&nbsp;</div>
        </div>
      </Layout>
    </div>
  );
}

export default ContactUs;
